import { ViewContainerRef } from "@angular/core";
import {
  EvrideoDialogOptions,
  EvrideoLoadingDialogOptions,
} from "../../components/common/evrideo-dialog/evrideo-dialog.component";

export abstract class IEvrideoDialogService {
  abstract openDialog(
    viewContainerRef: ViewContainerRef,
    options: EvrideoDialogOptions,
  ): Promise<boolean>;
  abstract openDialogWithLoading<T>(
    viewContainerRef: ViewContainerRef,
    loadingOptions: EvrideoLoadingDialogOptions,
    delayOrPromise: number | Promise<any>,
    successOptions?: (result: T) => EvrideoDialogOptions,
    errorOptions?: (error: any) => EvrideoDialogOptions,
  ): Promise<{ result: boolean; reason: "confirm" | "cancel" | "escape" }>;
}
